module.exports = __webpack_public_path__ + "static/media/ini4-90w.67955cb5.jpg";